<template>
    <DataTable
            ref="dataTable"
            v-redirect-if-no-permission:VOUCHERS
            title="Vouchers"
            :url="api.ACTIONS.VOUCHERS"
            :fields-hidden-main='["deleted_at","updated_at","is_public","type","amount","specific_location_whitelist","specific_location_blacklist","specific_service","use_times","customer_limits"]'
            :actions-extra-main="actionsExtraMain"
            :formatter="formatter"
            :titles="titles"
            :conditional-action="conditionalAction"
            :enable-edit="false"/>
</template>

<script>
    import DataTable from '@/components/wasilni/DataTable';

    export default {
        name: "VouchersList",
        title: 'Vouchers',
        components: {DataTable},
        computed: {
            conditionalAction() {
                return {
                    delete({deleted_at}) {
                        return !deleted_at;
                    },
                    restore({deleted_at}) {
                        return !!deleted_at;
                    },
                    edit({deleted_at}) {
                        return !deleted_at;
                    }
                }
            },
            titles() {
                return {
                    "id": "#",
                    "code": "Code",
                    "title": "Title",
                    "Details": "details",
                    "use_times": "Usage Times",
                    "is_public": "public",
                    "type": "type",
                    "amount": "Amount",
                    'start_date': "Start Date",
                    "end_date": "End Date",
                    "start_time": "Start Time",
                    "end_time": "End Time",
                    "created_at": "Created At",
                    "slice": "Slice"
                }
            },
            actionsExtraMain() {
                return {
                    restore: {
                        title: "Restore",
                        icon: "restore",
                        extras: {
                            color: "primary"
                        },
                        action: async (item) => this.$refs.dataTable.action(item, 'delete')
                    },
                    add: {
                        link: '/vouchers/add'
                    },
                    edit: {
                        title: "Edit",
                        icon: "edit",
                        extras: {
                            color: "secondary",
                        },
                        action: async (item) =>
                            this.$router.push({
                                name: 'VoucherDetails',
                                params: item
                            })
                    }
                };
            },
            formatter() {
                return {
                    start_date(value) {
                        return (new Date(value)).toDateString()
                    },
                    end_date(value) {
                        return (new Date(value)).toDateString()
                    },
                    start_time(value) {
                        return value ? (new Date(value)).toTimeString() : "No Start Time";
                    },
                    end_time(value) {
                        return value ? (new Date(value)).toTimeString() : "No End Time";
                    },
                    created_at(value) {
                        return (new Date(value)).toDateString();
                    },
                    customers_limit(value) {
                        return value || 'No Limit';
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>